import React, { useEffect, useState } from "react";
import CategoryList from "../components/category/CategoryList";
import { useDispatch, useSelector } from "react-redux";
import {
  createCategory,
  deleteCategory,
  getAllCategories,
} from "../redux/actions";
import EditCategoryModal from "../components/category/EditCategoryModal";
import CreateCategoryModal from "../components/category/CreateCategoryModal";
import { LoadingModal } from "../components/modal/loading";
import toast from "react-hot-toast";
import { handleFileUpload } from "../utils";

/**
 * @author
 * @function Category
 **/

export const Category = (props) => {
  const dispatch = useDispatch();

  const { categories, loading } = useSelector((state) => state.category);

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [loadingCreate, setLoadingCreate] = useState(false);

  async function handleCreate(payload) {
    try {
      setLoadingCreate(true);
      const img = payload.imageFile;

      const { key, path } = await handleFileUpload(img, "category");

      const data = {
        ...payload,
        img: { key, path },
      };

      dispatch(createCategory(data));
      setLoadingCreate(false);
    } catch (error) {
      const data = error?.response?.data;
      toast.error(data?.msg || "Error uploading category image");

      console.error("Error creating category:", error);

      setLoadingCreate(false);
    }

    setCreateOpen(false);
  }

  function handleUpdate(payload) {
    console.log("UPDATE payload:", payload);
    // call API then refresh list
    setEditOpen(false);
    setSelected(null);
  }

  const handleCategoryDelete = (categoryId) => {
    dispatch(deleteCategory(categoryId));
  };

  return (
    <div className="space-y-6">
      {(loadingCreate || loading) && (
        <LoadingModal text="Creating Category..." />
      )}

      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold text-slate-900">All Categories</h1>
        <button
          onClick={() => setCreateOpen(true)}
          className="rounded-xl bg-emerald-500 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-600"
        >
          Add Category
        </button>
      </div>

      {/* CategoryList: you need to wire Edit click */}
      <CategoryList
        categories={categories}
        onEdit={(cat) => {
          setSelected(cat);
          setEditOpen(true);
        }}
        onDelete={(cat) => {
          handleCategoryDelete(cat.id);
        }}
      />

      <CreateCategoryModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreate={handleCreate}
        categories={categories}
      />

      <EditCategoryModal
        open={editOpen}
        onClose={() => {
          setEditOpen(false);
          setSelected(null);
        }}
        onUpdate={handleUpdate}
        categories={categories}
        category={selected}
      />
    </div>
  );
};
